<template>
    <Section class="columns">

        <div class="columnLeft">
            <LeftColumnComponent/>
        </div>

        <div class="columnRight">
            <RightColumnComponent/>
        </div>

    </Section>


</template>

<script>

// import posed from 'vue-pose'
import RightColumnComponent from './GreoRight.vue';
import LeftColumnComponent from './GreoLeft.vue';

export default {
    name: 'ProjectGreo',

    components: {
        LeftColumnComponent,
        RightColumnComponent,
    },   
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

@mixin breakpoint1 { @media only screen and (min-width: 0px) { @content; } }
@mixin breakpoint2 { @media only screen and (min-width: 750px) { @content; } }
@mixin breakpoint3 { @media only screen and (min-width: 1024px) { @content; } }

.columns {

    @include breakpoint1 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        width: 100%;

        .columnLeft {
            width: 100%;
        }

        .columnRight {
            width: 100%;
            margin-top: 2em;
        }

    }

    @include breakpoint2 {
        display: flex;
        flex-direction: row;
        justify-content: center;
        height: 100%;
        width: 100%;

        .columnLeft {
            padding-right: 2.5em;
            margin-left: auto;
            align-items: right;
            width: 35%;
            position: relative;
        }

        .columnRight {
            padding-left: 2.5em;
            width: 40%;
            margin-right: auto;
            position: relative;
        }
    }
}

h1, h2, h3 {
    text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/Apps/Greo/ProjectGreo.vue